import React from "react";
import styles from "./styles/success-text.module.scss";

type SuccessTextProps = {
  success: string;
};
const SuccessText = ({ success }: SuccessTextProps) => {
  return <div className={styles.success_text}>{success}</div>;
};

export default SuccessText;
